import { render, staticRenderFns } from "./SingleTaskStatus.vue?vue&type=template&id=27dc603d&scoped=true&"
import script from "./SingleTaskStatus.vue?vue&type=script&setup=true&lang=js&"
export * from "./SingleTaskStatus.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SingleTaskStatus.vue?vue&type=style&index=0&id=27dc603d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dc603d",
  null
  
)

export default component.exports